module.exports = __webpack_public_path__ + "img/Logistics-Warehousetransportdouble.263cfa98.jpg";